import React, { useState } from 'react'
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom'
import CssBaseline from '@material-ui/core/CssBaseline'
import { ApolloProvider } from '@apollo/client'
import { Scrollbars } from 'react-custom-scrollbars'

import Home from './Home'
import Designer from './Designer'
import FinalSpecs from './FinalSpecs'
import Gallery from './Gallery'
import Theme from 'theme'
import Copyright from 'components/Global/Copyright'
import DashBoard from './DashBoard'
import TopBar from 'components/Global/TopBar'
import ApolloClient from '../ApolloInstance'
import { AuthWrapper } from 'store/AuthContext'
import styles from './pages.module.scss'

const App = () => {
  const [topBar, setTopBar] = useState(true)

  return (
    <ApolloProvider client={ApolloClient}>
      <AuthWrapper>
        <Router>
          <Theme>
            <Scrollbars style={{ width: '100vw', height: '100vh' }}>
              <div className={styles.scrollbarDiv}>
                <CssBaseline />
                {topBar && <TopBar />}
                <Switch>
                  <Route path="/Dashboard">
                    <DashBoard />
                  </Route>
                  <Route path="/Designer">
                    <Designer setTopBar={setTopBar} />
                  </Route>
                  <Route path="/Finalspecs">
                    <FinalSpecs />
                  </Route>
                  <Route path="/Gallery">
                    <Gallery />
                  </Route>
                  <Route path="/">
                    <Home />
                  </Route>
                </Switch>
                <Copyright />
              </div>
            </Scrollbars>
          </Theme>
        </Router>
      </AuthWrapper>
    </ApolloProvider>
  )
}

export default App
